import { NavLink } from "react-router-dom";
import { type Navtab } from "../schema";
import CultArrow from "./Icons/CultArrow";

export interface MainNavLinkProps {
  navItem: Navtab;
  onMainClick: () => void;
  onDropdownToggle: (id: string) => void;
  activeDropdown: string | null;
}

const MainNavLink = ({
  navItem,
  onMainClick,
  onDropdownToggle,
  activeDropdown,
}: MainNavLinkProps) => {
  return (
    <div className="flex w-full md:gap-2 xl:gap-3 items-center justify-between md:justify-normal">
      <NavLink
        to={navItem.to}
        onClick={onMainClick}
        className={({ isActive }) =>
          `duration-300 ease-in-out ${
            isActive || activeDropdown === navItem.to
              ? "text-cultiv-yellow"
              : "text-white group-hover:md:text-cultiv-yellow"
          }`
        }
      >
        <h6>{navItem.name}</h6>
      </NavLink>
      <button
        onClick={() => onDropdownToggle(navItem.to)}
        className="md:cursor-default justify-items-end"
      >
        <CultArrow
          className={`${
            activeDropdown === navItem.to
              ? "rotate-[270deg] stroke-cultiv-yellow"
              : "rotate-90 stroke-white"
          } size-6 md:size-4 group-hover:md:stroke-cultiv-yellow duration-300 ease-in-out`}
        />
      </button>
    </div>
  );
};

export default MainNavLink;
